import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "@ionic/core/css/core.css?vue&type=style&index=0&lang=css&external"
import "@ionic/core/css/ionic.bundle.css?vue&type=style&index=1&lang=css&external"
import "./App.vue?vue&type=style&index=2&id=026634d1&lang=css"

const __exports__ = script;

export default __exports__